<p-floatLabel>
  <p-select #providerStateDropdown
            id="providerDropdown"
            name="providerDropdown"
            [options]="providerStates"
            [(ngModel)]="providerState"
            [showClear]="!isRequired"
            [checkmark]="true"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="providerDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>